import { Grid2, Stack, Typography } from "@mui/material";
import { AnalyticCardWrapper, Progress } from "../accounts";
import { CampaignAnalytics, CampaignStatistics } from "../../types/apiTypes";
import { ProductStatisticsBlock } from "./ProductStatisticsBlock";
import { EngagementRate } from "../accounts/analityc/EngagementRate";

type Props = {
  total_accounts: number;
  statistics: CampaignStatistics;
  analytics: CampaignAnalytics;
};

export const ProductAnalyticsBlock = ({
  statistics,
  total_accounts,
  analytics,
}: Props) => {
  const {
    average_engagement_change,
    average_engagement_score,
    average_engagement_score_indicator,
    average_engagement_changed_at,
    committee_discovery,
  } = analytics;

  const { total_rate, your_data, external_data } = committee_discovery;

  const yourData = your_data ?? 0;
  const externalData = external_data ?? 0;

  const list = [
    { value: yourData, label: "CRM Data" },
    { value: externalData, label: "INFUSE Extension" },
    { value: 100 - externalData - yourData, label: "Gaps" },
  ];

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={{ xs: 12, md: 5.4 }} sx={{ display: "flex" }}>
        <AnalyticCardWrapper
          title="Buying Committee Members Identified"
          tooltip=""
          isProduct={true}
        >
          <Stack gap="16px" flexGrow={1} minWidth="300px">
            <Stack flexDirection={"row"} gap={"4px"} padding={"8px 0"}>
              <Typography
                variant="h2"
                color="#051123"
                sx={{ fontSize: "18px", lineHeight: "22px", fontWeight: 600 }}
              >
                {total_rate ?? 0}%
              </Typography>
              <Typography variant="body1" sx={{ color: "#797979" }}>
                of expected total
              </Typography>
            </Stack>
            <Stack gap="12px">
              <Stack gap="16px" direction="row">
                <Stack gap="16px" direction="row">
                  {list.map(({ label, value }) => (
                    <Stack gap="8px" flexDirection="row" key={label}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "12px",
                          lineHeight: "18px",
                          color: "#232323",
                        }}
                      >
                        {value}%
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          lineHeight: "18px",
                          color: "#797979",
                        }}
                      >
                        {label}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Stack>
              <Progress
                height={"20px"}
                primaryValue={your_data}
                secondaryValue={external_data}
              />
            </Stack>
          </Stack>
        </AnalyticCardWrapper>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 3 }} sx={{ display: "flex" }}>
        <AnalyticCardWrapper title="Statistics" tooltip="" isProduct={true}>
          <ProductStatisticsBlock
            statistics={statistics}
            total_accounts={total_accounts}
          />
        </AnalyticCardWrapper>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 3.6 }} sx={{ display: "flex" }}>
        <AnalyticCardWrapper
          title="Engagement Rate"
          tooltip=""
          isProduct={true}
        >
          <Stack alignItems="center" justifyContent="center" flexGrow={1}>
            <EngagementRate
              isProduct={true}
              value={average_engagement_score}
              indicator={average_engagement_score_indicator}
              indicatorChange={average_engagement_change}
              indicatorChangeAt={average_engagement_changed_at}
            />
          </Stack>
        </AnalyticCardWrapper>
      </Grid2>
    </Grid2>
  );
};
